import { ActionTypes } from '../constants';
import standardAction from '../../../utilities/standard-action';

export default function resetShippingLanePages() {
  return standardAction(ActionTypes.RESET_SHIPPING_LANES_PAGES);
}
